module.exports = __webpack_public_path__ + "img/empty-icon.4a8ea168.png";